import React, { useEffect, useState } from "react";
import sal from "sal.js";
import { useRouter } from 'next/router';
import { useUserContext } from "@/context/UserContext";
import logo from "../../public/images/logo/box-logo.png";
import BlogPostPreview from "./BlogPostPreview";

const Forum = () => {
  const router = useRouter();
  const { userLoggedIn } = useUserContext();
  const [isClient, setIsClient] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [previewPosts, setPreviewPosts] = useState([
    {
      id: "how-ai-is-disrupting-law-studies",
      title: "How AI is Disrupting Law Studies",
      description: "From drowning in case law to mastering legal concepts with artificial intelligence - discover how the next generation of UK law students is leveraging tools like Juree to excel in their studies while preparing for their dream legal careers. A former Durham law graduate shares their perspective on this game-changing evolution in legal education.",
      image: logo,
    },
  ]);

  return (
    <>
      <div className="rbt-main-content mr--0">
        <div className="rbt-daynamic-page-content">
          <div className="rbt-dashboard-content">
            <div className="content-page">
              <div className="forum-container">
                <div className="jureeltd-generartor-section jureeltd-section-gap">
                  <div
                    className="section-title text-center sal-animate"
                    data-sal="slide-up"
                    data-sal-duration="700"
                    data-sal-delay="100"
                  >
                    <h2 className="title w-600 mb--20">
                      Juree Blog
                    </h2>
                    <p className="description b1">
                      All the latest news and updates for UK Law Students
                    </p>
                  </div>
                  <div className="forum-categories-section">
                    <BlogPostPreview previewPosts={previewPosts} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forum;
